/**
 * `@loot-os/react/retail-box`: the Retail Box opener (a product box on a studio plinth, for stores
 * that sell apparel, sneakers, watches and the like). It renders with three.js, so it ships on its
 * own entry point with `three`, `@react-three/fiber`, `@react-three/drei`,
 * `@react-three/postprocessing` and `postprocessing` as optional peer dependencies. A host that
 * shows boxes whose opener style is `retail_box` calls `registerRetailBox()` once; the scene itself
 * loads on first use.
 */

import { defineStageOpener, registerOpener } from "./openers/registration";
import { RETAIL_BOX_TOKENS } from "./openers/retailBox/tokens";

export const retailBoxOpener = defineStageOpener(
  () => import("./openers/retailBox/RetailBoxOpener"),
  RETAIL_BOX_TOKENS,
);

/** Registers Retail Box for every opener on the page. Idempotent. */
export function registerRetailBox(): void {
  registerOpener("retail_box", retailBoxOpener);
}

export { RETAIL_BOX_TOKENS };
